import { Component, inject } from '@angular/core';
import {
  IonCard,
  IonAvatar,
  IonCardTitle,
  IonCardContent,
  IonIcon,
  IonCardHeader} from "@ionic/angular/standalone";
import { addIcons } from 'ionicons';
import { mailOutline, callOutline, locationOutline, personOutline } from 'ionicons/icons';
import { ExaScanUser } from 'src/app/_Services/apih/exa-scan-user';

@Component({
  selector: 'app-current-user-card',
  standalone: true,
  templateUrl: './current-user-card.component.html',
  styleUrls: ['./current-user-card.component.scss'],
  imports: [
    IonCard,
    IonAvatar,
    IonCardTitle,
    IonCardContent,
    IonIcon,
    IonCardHeader
]
})
export class CurrentUserCardComponent {
  protected readonly userSrv = inject(ExaScanUser);

  currentUser = this.userSrv.currentUser;

  constructor() {
    addIcons({ mailOutline, callOutline, locationOutline, personOutline });
  }
}